/* ---------------------------------------------------------------------------
   UF STICKY ADD TO CART

   Appears once the real Add to Cart has scrolled out of view, and proxies it.

   PROXY, NOT DUPLICATE. The bar's button forwards its click to the real
   submit button inside the product form, so the variant, quantity and selling
   plan in effect are whatever the buy box already has — there is no second
   state to keep in step, and Seal Subscriptions' rewrite of the cart form is
   used rather than worked around. A hidden button still submits its form when
   clicked, so being off-screen changes nothing.

   The price and the label are MIRRORED from the real button for the same
   reason. data-button-price is Afterpay's hook and must exist exactly once on
   the page; uf-pdp.js also selects a single [data-uf-atc-price]. Copying text
   out of the real node keeps both of those true.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ufStickyBound) return;
  window.__ufStickyBound = true;

  function init() {
    var bar = document.querySelector('[data-uf-sticky]');
    var atc = document.querySelector('[data-uf-atc]');
    if (!bar || !atc) return;

    var barBtn = bar.querySelector('[data-uf-sticky-atc]');
    var barPrice = bar.querySelector('[data-uf-sticky-price]');
    var barLabel = bar.querySelector('[data-uf-sticky-label]');
    var barStock = bar.querySelector('[data-uf-sticky-stock]');
    var realPrice = atc.querySelector('[data-uf-atc-price]');
    var realLabel = atc.querySelector('[data-uf-atc-label]');
    var realStock = document.querySelector('[data-uf-stock-text]');

    /* ---- forward the click to the real button */

    if (barBtn) {
      barBtn.addEventListener('click', function () {
        if (atc.disabled) return;
        atc.click();
      });
    }

    /* ---- keep price, label and availability in step */

    function sync() {
      if (barPrice && realPrice) {
        barPrice.textContent = realPrice.textContent;
        /* The real price is hidden while sold out; match that rather than
           showing a stale figure next to a disabled button. */
        barPrice.hidden = realPrice.hidden;
      }
      if (barLabel && realLabel) barLabel.textContent = realLabel.textContent;
      if (barBtn) barBtn.disabled = atc.disabled;

      /* Stock is mirrored text AND mirrored colour. The buy box decides what
         counts as "nearly sold out" and which colour that is; reading the
         resolved colour back off the element means this bar can never disagree
         with it, even if the thresholds or the palette change later. */
      if (barStock && realStock && bar.hasAttribute('data-uf-sticky-mirror-stock')) {
        var text = realStock.textContent.trim();
        barStock.textContent = text;
        barStock.hidden = text === '';
        barStock.style.color = window.getComputedStyle(realStock).color;
      }
    }

    sync();

    /* uf-pdp.js rewrites the real button on every variant and plan change and
       does not announce it, so the bar watches rather than listens. */
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(atc, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'hidden']
      });
    }

    /* ---- show it once the real button is out of sight

       Observing the BUTTON rather than the whole buy box: the card is tall
       enough that on a phone it can still be technically on screen while the
       part that matters is long gone. What the bar replaces is the button, so
       the button is what decides. */

    /* A floating third-party launcher — the rewards widget on this store — sits
       at the bottom of the viewport and ends up underneath this bar. Lifting it
       by the bar's height keeps it reachable instead of switching the feature
       off. Opt-in by selector, because hard-coding another app's id here would
       break silently the day that app changes. */
    var offsetSel = bar.getAttribute('data-uf-sticky-offset');
    var offsetEls = offsetSel
      ? Array.prototype.slice.call(document.querySelectorAll(offsetSel))
      : [];
    var offsetPrev = offsetEls.map(function (el) {
      return el.style.bottom;
    });

    function reveal(on) {
      bar.classList.toggle('is-visible', on);

      offsetEls.forEach(function (el, i) {
        if (on) {
          el.style.transition = 'bottom 260ms cubic-bezier(0.3, 0.8, 0.3, 1)';
          el.style.bottom = bar.offsetHeight + 'px';
        } else {
          el.style.bottom = offsetPrev[i];
        }
      });
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* Only once it has gone UP out of view. Scrolled off the bottom —
               which is the state on first paint before anyone has moved —
               would otherwise show the bar over the buy box it duplicates. */
            var above = entry.boundingClientRect.top < 0;
            reveal(!entry.isIntersecting && above);
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      ).observe(atc);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
